import React, { useState, useEffect } from "react";
import Base from "../admin_components/Admin_Base";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import "./Manualinvoicelist.css";
import jsPDF from "jspdf";
import { Breadcrumbs, Link, TextField } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { ADMIN_API_BASE_URL } from "../Auth/Api";
import authAxios from "../Auth/useAxios";
import { ClipLoader } from "react-spinners";

const Manualinvoicelist = () => {
  const [selectedPaymentreciept, setSelectedPaymentreciept] = useState(null);
  const [manualInvoiceList, setManualInvoiceList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 15;
  const [enabled, setEnabled] = useState(true);

  const fetchManualPayments = async () => {
    try {

      const response = await authAxios.get(`${ADMIN_API_BASE_URL}/main/admin/get-all-manual-payments`);
      setManualInvoiceList(response.data);
      console.log(response.data);
    } catch (err) {
      setError(err.message);
      console.error('Error fetching manual payments:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchManualPayments();
  }, []);


  const totalPages = Math.ceil(manualInvoiceList.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const paginatedRequests = manualInvoiceList.slice(startIndex, endIndex);

  const handleViewInvoice = (Paymentreciept) => {
    setSelectedPaymentreciept(Paymentreciept);
  };

  const handleDownloadPaymentreciept = () => {
    if (selectedPaymentreciept) {
      const doc = new jsPDF();

      // Set background color for the header
      doc.setFillColor(57, 204, 113); // Green
      doc.rect(0, 0, 210, 30, "F"); // Fill the header area

      // Set font and size for the invoice heading
      doc.setFont("Arial, sans-serif", "bold");
      doc.setFontSize(24);
      doc.setTextColor(227, 39, 18); // Red text
      doc.text("RAJASREE TOWNSHIPS", 105, 20, { align: "center" });

      // Reset text color for other sections
      doc.setTextColor(0, 0, 0); // Black text


      // Add invoice to section
      doc.setFontSize(14);
      doc.setTextColor(227, 39, 18); // Red text
      // doc.text("PAYMENT RECEIPT TO", 20, 60);
      doc.setFont("helvetica", "normal");
      doc.setTextColor(0, 0, 0); // Black text


      // Define table data
      const tableData = [
        ["PAYMENT RECEIPT NUMBER", `PRN-${selectedPaymentreciept.sno.toString().padStart(4, "0")}`],
        ["DATE", selectedPaymentreciept.PaymentrecieptcreatedDate],
        ["Customer Name", selectedPaymentreciept.customerName],
        ["Property Name", selectedPaymentreciept.propertyName],
        ["DESCRIPTION", "AMOUNT PAID"],
        [`EMI Payment (${selectedPaymentreciept.emiMonth})`, `${selectedPaymentreciept.amount}`],
        ["PAYMENT METHOD", selectedPaymentreciept.paymentMethod],
      ];

      // Set table position and styling
      const startX = 20;
      const startY = 40;
      const rowHeight = 10;
      const colWidth1 = 80; // Width of the first column
      const colWidth2 = 100; // Width of the second column

      // Draw table rows
      tableData.forEach((row, index) => {
        const y = startY + index * rowHeight;

        // Draw cell borders
        doc.rect(startX, y, colWidth1, rowHeight); // First column
        doc.rect(startX + colWidth1, y, colWidth2, rowHeight); // Second column

        // Add text to cells
        doc.setFont("helvetica", "bold"); // Bold for left content
        doc.setFontSize(12);
        doc.text(row[0], startX + 5, y + 7); // First column text
        doc.text(row[1], startX + colWidth1 + 5, y + 7); // Second column text
      });

      // Add terms and conditions
      doc.setFont("helvetica", "bold");
      doc.setTextColor(0, 0, 255); // Blue text
      doc.text("TERMS & CONDITIONS", 20, startY + tableData.length * rowHeight + 10);
      doc.setFont("helvetica", "normal");
      doc.setTextColor(0, 0, 0); // Black text

      const terms = [
        "Management shall not be liable for any payments that have not been approved by the Management.",
        "The amount paid should be directly deposited into our company's HDFC bank account only and a proper receipt must be obtained.",
        "The amount paid in the scheme is non-refundable under any circumstances. Members have the option to switch to a different scheme in a different group with proper approval from the management.",
        "Your payment amount can be directly deposited to our company’s HDFC Bank account (A/C No: 50200009660286, IFSC No: HDFC0002413) through digital payments (Google Pay/Phone Pay/Paytm/NEFT/IMPS) or debit/credit cards via our company representative.Payment in cash is also available, and a proper receipt must be obtained from the management.",
      ];

      // Reduce font size for bullet points
      doc.setFontSize(10); // Smaller font size for bullet points

      let termY = startY + tableData.length * rowHeight + 25; // Adjust Y position for the first bullet point
      terms.forEach((term, index) => {
        doc.text(`${index + 1}. ${term}`, 20, termY, { maxWidth: 170 }); // Adjusted maxWidth
        termY += 14; // Reduced space between points
      });

      doc.setFontSize(12); // Reset to default font size

      // Add footer with colors (vertical layout)
      doc.setFontSize(10, "bold");
      doc.setTextColor(255, 34, 0); // Red text

      let footerY = doc.internal.pageSize.height - 15; // Position at the bottom of the page
      let footerX = 20; // Starting X position for the footer

      doc.text("Website: www.rajasreetownship.in", footerX, footerY);
      doc.text("| Email: Info@rajasreetownships.in", footerX + 60, footerY);
      doc.text(" | Customercare: +91 6262 666 999", footerX + 120, footerY);

      // Save the PDF
      doc.save(`Paymentreciept_${selectedPaymentreciept.sno}.pdf`);
    }
  };
  const handleDownloadCSV = () => {
    const csvContent =
      "data:text/csv;charset=utf-8," +
      manualInvoiceList
        .map((invoice) => Object.values(invoice).join(","))
        .join("\n");
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "manual_invoice_list.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };


  const handleChange = (e) => {
    const value = e.target.value === 'true';
    setEnabled(value);
    updatePaymentGatewayStatus(value);
  };


  const updatePaymentGatewayStatus = async (enabled) => {
  try {
    const response = await authAxios.put(
      `${ADMIN_API_BASE_URL}/main/admin/edit-gateway-button`,JSON.stringify(enabled));
    console.log(response.data);
    alert(response.data);
  } catch (error) {
    console.error('Error updating gateway status:', error);
    alert('Something went wrong!');
  }
};

  return (
    <Base>
      {loading ? (
        <div style={{ display: "flex", justifyContent: "center", marginTop: "300px" }}>
          <ClipLoader color="darkslategrey" size={50} />
        </div>
      ) : error ? (
        <div>{error}</div>
      ) : (
        <>
          <div
            className="pt-3 mt-5"
            style={{ display: "flex", justifyContent: "flex-end", paddingRight: "20px" }}
          >
            {/* Breadcrumbs */}
            <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
              <Link color="inherit" href="/admin/dashboard" sx={{ color: "blue", fontWeight: "bold" }}>
                Dashboard
              </Link>
            </Breadcrumbs>
          </div>



          <h2 className="text-center fw-bold main_heading">Manual Payment Receipt List</h2>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <hr style={{ width: "80%" }} />
          </div>


          <div className="container">
            <div className="d-flex justify-content-end gap-3">

                <div>
                <label htmlFor="gatewayToggle" className="form-label fw-bold">Enable Payment Gateway </label>
                <select   id="gatewayToggle"  value={enabled} onChange={handleChange}  className="form-select" >
                  <option value="true">Enabled</option>
                  <option value="false">Disabled</option>
                </select>
              </div>

              <div>
                <button className="btn btn-success " onClick={handleDownloadCSV}>
                  Download CSV
                </button>
              </div>
            </div>

            <div className="responsive-table-container">
              <Table className="responsive-table">
                <Thead>
                  <Tr>
                    <Th>S.No</Th>
                    <Th>Customer Name</Th>
                    <Th>Property Name</Th>
                    <Th>Passbook No</Th>
                    <Th>EMI Year</Th>
                    <Th>EMI Month</Th>
                    <Th>Payment Receipt Created Date</Th>
                    <Th>Payment Receipt</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {paginatedRequests.map((transaction, index) => (
                    <Tr key={transaction.sno || index}>
                      <Td>{index + 1}</Td>
                      <Td>{transaction.customerName}</Td>
                      <Td>{transaction.propertyName}</Td>
                      <Td>{transaction.passbook}</Td>
                      <Td>{transaction.emiYear}</Td>
                      <Td>{transaction.emiMonth}</Td>
                      <Td>{transaction.receivedDate}</Td>
                      <Td>
                        <button
                          className="invoice-button-list"
                          onClick={() => handleViewInvoice(transaction)}
                        >
                          View Payment Receipt
                        </button>
                      </Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </div>
          </div>

          {selectedPaymentreciept && (
            <div className="invoice-modal-list">
              <div className="invoice-content-list">
                <h2 className="manualpaymentreciept">Rajasree Townships</h2>
                <p>
                  <strong>Payment Receipt Number:</strong> PRN-
                  {selectedPaymentreciept.sno}
                </p>
                <p>
                  <strong>Date:</strong>{" "}
                  {selectedPaymentreciept.PaymentrecieptcreatedDate}
                </p>
                <h3 className="customerpayment">Customer Details</h3>
                <p>
                  <strong>Name:</strong> {selectedPaymentreciept.customerName}
                </p>
                <p>
                  <strong>Passbook No:</strong> {selectedPaymentreciept.passbook}
                </p>
                <p>
                  <strong>Property Name:</strong>{" "}
                  {selectedPaymentreciept.propertyName}
                </p>
                <p>
                  <strong>Transaction Number:</strong>{" "}
                  {selectedPaymentreciept.transactionNumber}
                </p>
                <p>
                  <strong>Status:</strong> {selectedPaymentreciept.status ? "Approved" : "Pending"}
                </p>
                <h3 className="transactionpayment">Transaction Details</h3>
                <p>
                  <strong>Amount:</strong> ₹{selectedPaymentreciept.amount}
                </p>
                <p>
                  <strong>Payment Method:</strong>{" "}
                  {selectedPaymentreciept.paymentMethod}
                </p>
                <p>
                  <strong>Due Date:</strong> {selectedPaymentreciept.dueDate}
                </p>
                <button
                  className="btn btn-primary"
                  onClick={handleDownloadPaymentreciept}
                >
                  <FontAwesomeIcon icon={faDownload} /> Download Payment Receipt
                </button>
                <button
                  className="btn btn-danger"
                  onClick={() => setSelectedPaymentreciept(null)}
                >
                  Close
                </button>
              </div>
            </div>
          )}

          <div className="pagination-controls-payment-history">
            <button
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
            >
              Previous
            </button>
            <span className="mx-2">
              Page {currentPage} of {totalPages}
            </span>
            <button
              onClick={() =>
                setCurrentPage((prev) => Math.min(prev + 1, totalPages))
              }
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </div>
        </>
      )}
    </Base>
  );
};

export default Manualinvoicelist;
